import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';

const CheckboxField = ({
  name = 'remember',
  checkboxText = <FormattedMessage id="app.login.remember_me_checkbox"/>,
  className = "",
  value = false,
}) => {
  const [checkedValue, setCheckedValue] = useState(value);

  useEffect(() => {
    setCheckedValue(value);
  }, [value]);

  return (
    <Field name={name}>
      {({ field, form }) => (
        <div className={`custom-control custom-control-alternative custom-checkbox ${className}`}>
          <input
            className="custom-control-input"
            id={`checkbox-${name}`}
            type="checkbox"
            checked={checkedValue}
            onChange={() => {
              setCheckedValue(!checkedValue);
              form.setFieldValue(name, !checkedValue);
            }}
            name={name}
          />
          <label className="custom-control-label" htmlFor={`checkbox-${name}`}>
            <span className="text-muted">{checkboxText}</span>
          </label>
        </div>
      )}
    </Field>
  );
};

export { CheckboxField };
